import { useEffect, useState, useRef } from "react";
import Sider from "../../comps/sider/main";
import './main.css';
import {TagTwoTone, ClockCircleOutlined, CommentOutlined, UserSwitchOutlined, EyeInvisibleOutlined, DeleteOutlined, PlusOutlined, SendOutlined, ThunderboltOutlined, GlobalOutlined, UploadOutlined, UserAddOutlined, CopyOutlined, CrownOutlined, FireFilled, PlusSquareOutlined, AppleFilled, MailOutlined, CameraOutlined, EyeOutlined, PropertySafetyFilled } from '@ant-design/icons';
import { Alert, Switch, Drawer, Radio, Input, Card, Tag, Divider, Select, Button, Collapse, Upload, Tooltip, message, Popconfirm, Checkbox, Dropdown, Timeline, Flex } from 'antd';
import { EditText, EditTextarea } from 'react-edit-text';
import 'react-edit-text/dist/index.css';
import axios from 'axios';
import callAPI from "../../comps/fetch/main";
import { json } from "react-router-dom";
import Title from "antd/es/skeleton/Title";
import AccessOrNot from "../../funcs/accessOrNot";
import { v4 as uuidv4 } from 'uuid';

import CrownReturn from '../crownPremium/main'
import { BsCashCoin, BsMagnet  } from "react-icons/bs";
import {InstaDMLayout, InstagramCommentLayout } from "../instaDMLayout/main";
const { TextArea } = Input;


const htmlToText = (html) => {
      try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        console.log("=-=-=-=-=-doc.body.textContent" , doc.body.textContent)
        if(doc.body.textContent == "undefined" || doc.body.textContent == null || doc.body.textContent == "null") 
          return ""
        return doc.body.textContent || "";
      } catch (err) {
        console.error("Error in htmlToText:", err);
        return "";
      }
};



const ShopifyProductLayout = ({ data }) => {
  const product = data;
  const variant = product.variants?.[0];
  const allImages = product?.node?.media?.nodes || [];

  return (
    <div style={{
      maxWidth: 400,
      minWidth:"400px",
      margin: "0 auto",
      fontFamily: "sans-serif",
      color: "#333",
      background: "#fff",
      borderRadius: 12,
      overflow: "hidden",
      boxShadow: "0 0 10px rgba(0,0,0,0.08)"
    }}>
      {/* Product Image */}
      {/* <p>Preview in beta</p> */}


      <div style={{
        width: "100%",
        height: 400,
        backgroundImage: `url(${allImages[0]?.preview?.image?.url })`,
        backgroundSize:"contain",
        backgroundRepeat:"no-repeat",
        backgroundPosition: "center"
      }} />

      {/* Thumbnails */}
      <div style={{
        display: "flex",
        justifyContent: "center",
        gap: 10,
        padding: "10px 16px",
        overflowX: "auto"
      }}>
        {allImages.map((img, index) => (
          <img
            key={img.id || index}
            src={img?.preview?.image?.url}
            // onClick={() => setPreviewImage(img.src)}
            alt={`Thumbnail ${index+1}`}
            style={{
              width: 60,
              height: 60,
              objectFit: "cover",
              borderRadius: 8,
              // border: previewImage === img.src ? "2px solid #000" : "1px solid #ddd",
              cursor: "pointer"
            }}
          />
        ))}
      </div>

      {/* Product Info */}
      <div style={{ padding: "16px 20px" }}>
        {/* Title */}
        <h2 style={{ margin: 0, fontSize: 20 }}>{product?.node?.title}</h2>

        {/* Vendor */}
        {/* <p style={{ margin: "4px 0", fontSize: 14, color: "#888" }}>{product.vendor}</p> */}

        {/* Tags */}
        <div style={{ margin: "8px 0", fontSize: 12, color: "#999" }}>
          {/* {product.tags.split(',').map(tag => (
            <span key={tag.trim()} style={{
              background: "#f2f2f2",
              padding: "4px 8px",
              borderRadius: 6,
              marginRight: 6,
              display: "inline-block"
            }}>{tag.trim()}</span>
          ))} */}
        </div>

        {/* Price */}
        <div style={{
          fontSize: 22,
          fontWeight: 600,
          margin: "12px 0 4px"
        }}>
          {variant?.price}
        </div>

        {/* Availability */}
        {/* <p style={{ fontSize: 14, color: variant?.inventory_quantity > 0 ? "green" : "red" }}>
          {variant?.inventory_quantity > 0 ? "In Stock" : "Out of Stock"}
        </p> */}

        
      </div>

    </div>
  );
};


  const stepTypeTitle = (type) =>{

      if(type ===   "order-confirm") return "Order Confirmed"
      if(type ===   "whatsapp") return "WhatsApp Community Link"
      if(type ===  "upsell") return "Upsell Product"

  }


export default function ShopifyPreview({step, data,previewData,igData}){

    // console.log("-=-=-=-=ig data-=-=-==--=-=" , igData)


    function extractFirstLink(text) {
    const pattern = /(?:https?:\/\/)?(?:www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\/[^\s"'<>()]*)?/g;
    const matches = text.match(pattern);
    return matches ? matches[0] : null;
  }

  const [tempData,setTempData] = useState(data)
  const [linkPreview, setLinkPreview] = useState()
  const [loadingstate, setloadingState] = useState()


  

  useEffect( () => {

    
    if(data?.sp_send_type == "link"){
      setLinkPreview()
      if ( extractFirstLink(data?.sp_send_message) != null ){
          callAPI( { url :  "/short_url" , method: "POST" , body:{"url" :extractFirstLink(data?.sp_send_message),
            "only_preview":true,  }, loadingState: setloadingState, dataState: (data) => {
                setLinkPreview(data.data)
                // console.log(data.data)
            }})
      
    }
  }

  }, [data])


  console.log("Curent prview Steps--=-=-=-=-=-=-=-=-",step)

  if (step == "trigger"){
    return <InstagramCommentLayout data={data} igData={igData}/>

  }

  if (step == "sp_product"){
    if (data?.sp_product)
    return <ShopifyProductLayout data={data.sp_product}/>
    else
    return <p>Select the product</p>
  }


  if (step == "send_type"){
    
  if (data?.sp_send_type === "link"){

    return <InstaDMLayout>
    <>

    {extractFirstLink(data?.sp_send_message) != null && (
      loadingstate ? (
        <div
          style={{
            background: "#222",
            color: "#fff",
            borderRadius: 12,
            padding: "16px",
            margin: "16px 10px 8px auto",
            maxWidth: "80%",
            textAlign: "left",
            fontSize: 15,
            fontWeight: 500,
            boxShadow: "0 2px 8px rgba(79,140,255,0.08)",
            display: "block",
            border: "1px solidrgb(70, 71, 71)",
            minHeight: 80,
            display: "flex",
            alignItems: "center",
            gap: 12
          }}
        >
          <span className="ant-spin-dot ant-spin-dot-spin" style={{ fontSize: 22, color: "#4f8cff" }}>
            <i className="ant-spin-dot-item" />
            <i className="ant-spin-dot-item" />
            <i className="ant-spin-dot-item" />
            <i className="ant-spin-dot-item" />
          </span>
          <span>Loading preview…</span>
        </div>
      ) : linkPreview ? (
        
        <a href={linkPreview.url} target="_blank">
        <div
          style={{
            background: "#222",
            color: "#fff",
            borderRadius: 12,
            padding: "16px",
            margin: "16px 10px 8px auto",
            maxWidth: "80%",
            textAlign: "left",
            fontSize: 15,
            fontWeight: 500,
            boxShadow: "0 2px 8px rgba(79,140,255,0.08)",
            display: "block",
            border: "1px solid #4f8cff"
          }}
        >
          {linkPreview.image && (
            <img
              src={linkPreview.image}
              alt="Preview"
              style={{
                width: "100%",
                // maxHeight: 140,
                objectFit: "cover",
                borderRadius: 8,
                marginBottom: 10,
                background: "#111"
              }}
            />
          )}
          <p
            className="title"
            style={{
              fontWeight: 600,
              fontSize: 16,
              margin: "0 0 4px 0",
              color: "#4f8cff",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            }}
          >
            {linkPreview.title}
          </p>
          <p
            style={{
              margin: 0,
              fontSize: 14,
              color: "#ccc",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical"
            }}
          >
            {linkPreview.description}
          </p>
        </div>
        </a>
      ) : null
    )

  }
  <p
      className="sender-message"
      style={{
        background: "#4f8cff",
        color: "white",
        borderRadius: "16px 16px 4px 16px",
        padding: "10px 16px",
        margin: "16px 10px 8px auto",
        maxWidth: "80%",
        textAlign: "left",
        fontSize: 15,
        fontWeight: 500,
        boxShadow: "0 2px 8px rgba(79,140,255,0.08)",
        display: "block"
      }}
    >
    {data?.sp_send_message}</p>
  </>
  </InstaDMLayout>
  
  }

  

  else{

    return <InstaDMLayout>

      <div className="card-message">
        <img src={data?.sp_product?.node?.featuredMedia?.preview?.image?.url } />
        <div className="card-content">
        <h3>{data?.sp_product?.node?.title}</h3>
        <p>{data?.sp_product?.node?.description?.substring(0,100) }</p>
        <div className="card-button">
        See Images
        </div>
        {/* <div className="card-button">
        Visit website
        </div> */}
        </div>

      </div>
      
    </InstaDMLayout>

  }

}



  if (step == "left_chat" || step == "left_order"){


    return <InstaDMLayout>


      <div className="shopify-preview">
      <Timeline tailColor="white" mode="right" style={{tailColor:"white"}}>

        {Object.values(previewData?.followupMessages?.[step] || {})?.map((f, i) => (
            <Timeline.Item key={i} color="blue">
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "space-between",
                  marginBottom: 6,
                  flexDirection:"column"
                }}
              >
                <span style={{ fontWeight: "600", fontSize: 15, color:"#555"}}>
                  Follow-up #{i + 1}
                </span>


              <div style={{ marginBottom: 10, fontSize: 13, color: "#ccc0c0ff" }}>
                Wait {" "} {f.follow_up_time} Minutes
       
                after {i == 0 ?  step == "left_chat_followup"  ? "Message Sent" : "Added to card" : `Follow-up #${i}`}
              </div>

              <div className={ "card-message" }>
                        <div className="card-content">
                        <h3 style={{color:"white", textAlign:"start"}}>{f.title}</h3>
                        <p style={{color:"white", textAlign:"start"}}>{f.subtitle}</p>
                        <div style={{color:"white"}} className="card-button">
                        {f.btn_text1}
                        </div>
                  
                        </div>

                      </div>
                </div>
            </Timeline.Item>
          ))}

      </Timeline>
      </div>
      {/* <div className={`${previewData?.followupMessage?.button?.length > 0 ? "card-message" : "insta-text-message"}`}>
        <div className="card-content">
        <h3>{previewData?.followupMessage?.message}</h3>
        { previewData?.followupMessage?.button && <div className="card-button">
      { previewData?.followupMessage?.button }
        </div>
  }
        </div>

      </div> */}
      
    </InstaDMLayout>

  }


  if (step == "post_purchase"){

    console.log(
      "Preview Data post purchase Messages: ", previewData?.postPurchase
    )

    return <InstaDMLayout>


      <div className="shopify-preview">
      <Timeline tailColor="white" mode="right" style={{tailColor:"white"}}>

        {previewData?.postPurchase?.map((f, i) => (
            <Timeline.Item key={i} color="blue" style={{marginRight:"20px"}}>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "space-between",
                  marginBottom: 6,
                  flexDirection:"column"
                }}
              >

                
                {/* <span style={{ fontWeight: "600", fontSize: 15, color:"#555"}}>
                  Follow-up #{i + 1}
                </span> */}


              <div style={{ marginBottom: 10, fontSize: 13, color: "#ccc0c0ff", }}>
                { f.delay == "now" ? "Immediately" :`Wait ${f.delay} Minutes`}
       
                {" "} after {" "} {i == 0 ? "purchase completed" : stepTypeTitle(previewData?.postPurchase[i-1]?.type)}
              </div>

              {
               f.type == "order-confirm" && <div className= "insta-text-message" style={{marginRight:"-10px"}}>
                    <p style={{color:"white", textAlign:"left"}}>{f?.message}</p>
                  </div>
              }
              

               {
               f.type == "whatsapp" && <div className={ "card-message"} style={{marginRight:"-10px"}}>
                      <div className="card-content">
                      <h3 style={{color:"white", textAlign:"start"}}>{f.message}</h3>
                      <div style={{color:"white"}} className="card-button">
                      {f.cta}
                      </div>
                
                      </div>

                    </div>
                }

             {
               f.type == "upsell" && <>
               
                      <div className= "insta-text-message" style={{marginRight:"-10px"}}>
                        <p style={{color:"white", textAlign:"left"}}>{f?.title}</p>
                      </div>
             
                      <Flex 
                      className="hscroll"
                      style={{
                          // display: "flex",
                          // flexDirection: "row",
                          // flexWrap: "nowrap",
                          overflowX: "auto",
                          // maxWidth: "100%",
                          gap: "12px",
                          paddingBottom: "8px",
                          width:f?.products?.length > 1 ?"60%" : "100%",
                          minWidth:"250px",
                          marginRight: f?.products?.length > 1 ? "-20px" : "-60px",

                        }}
                        onWheel={(e) => {
                          const container = e.currentTarget;
                          // Only trigger if there's horizontal scroll
                          if (container.scrollWidth > container.clientWidth) {
                            container.scrollLeft += e.deltaY;
                            e.preventDefault(); // prevent page vertical scroll
                          }
                        }}
                      >
                      {f?.products?.map( (product , item) =>
                        <div className="card-message" style={{borderRadius:"10px",
                            flex: "0 0 220px", // 👈 fixed width card so scroll works
                            background: "#222",
                            // minWidth:"300px" // just to see card boundary
                          }}
                        >
                          <img style={{maxWidth:"100%", maxHeight:"100px", objectFit:"cover"}} src={product?.node?.featuredMedia?.preview?.image?.url} />
                          <div className="card-content">
                          <h3 style={{color:"white", textAlign:"start"}}>{product?.node?.title}</h3>
                          <p style={{color:"white", textAlign:"start"}}>{htmlToText(product?.node?.description)?.substring(0,100) }</p>
                          
                          <div style={{color:"white", textAlign:"center"}} className="card-button">
                          {product?.cta}
                          </div>
                          

                          </div>
                          </div>
                        )}
                      </Flex>
                      

                    </>
                }

              {/* <div className={ "card-message" }>
                        <div className="card-content">
                        <h3 style={{color:"white", textAlign:"start"}}>{f.title}</h3>
                        <p style={{color:"white", textAlign:"start"}}>{f.subtitle}</p>
                        <div style={{color:"white"}} className="card-button">
                        {f.btn_text1}
                        </div>
                  
                        </div>

                      </div> */}
                </div>
            </Timeline.Item>
          ))}

      </Timeline>
      </div>
      {/* <div className={`${previewData?.followupMessage?.button?.length > 0 ? "card-message" : "insta-text-message"}`}>
        <div className="card-content">
        <h3>{previewData?.followupMessage?.message}</h3>
        { previewData?.followupMessage?.button && <div className="card-button">
      { previewData?.followupMessage?.button }
        </div>
  }
        </div>

      </div> */}
      
    </InstaDMLayout>

  }


   if (step == "thanks"){

    return <InstaDMLayout>

      <div className="insta-text-message">
        <div className="card-content" style={{paddingBottom:"10px"}}>
        <h3>{data?.thanksmessage}</h3>
        </div>

      </div>
      
    </InstaDMLayout>

  }
  

  
}
